module.exports = __webpack_public_path__ + "static/media/focus-why-mindfulness-text-de.d8377e43.md";


//////////////////
// WEBPACK FOOTER
// ./src/data/playbooks/focus-why-mindfulness-text-de.md
// module id = 479
// module chunks = 18